import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles({
  row: {
    height: '49px',
  },
});

const LinhaVaziaTabelaGruposVisualizacao = () => {
  const classes = useStyles();

  const tableCell = () => {
    const colunas = [];
    let index = 0;

    for (let i = 0; i < 2; i++) {
      colunas.push(<TableCell key={index++} />);
    }

    return colunas;
  };

  return (
    <TableRow
      data-testid="linha-vazia-tabela-grupos-visualizacao"
      className={classes.row}
    >
      {tableCell()}
    </TableRow>
  );
};

export default LinhaVaziaTabelaGruposVisualizacao;
